// Dead email address prompt (backend flag `email_undeliverable`, set in
// SiteAPI::prepareCurrentUser()). Kept free of React/DOM imports so it can be unit tested.

export const EMAIL_UNDELIVERABLE_STORAGE_KEY = 'emailUndeliverablePromptShown';

/**
 * @param {object} user current user object (BobTVUser or plain)
 * @return {boolean} true when the backend says the member's address cannot receive email
 */
export function isEmailUndeliverable(user) {
    return !!user && user.email_undeliverable === 1;
}

/**
 * sessionStorage access can throw (privacy mode, disabled storage): treat that as "no storage".
 *
 * @param {Storage|undefined} storage
 * @return {boolean}
 */
export function wasPromptShown(storage) {
    try {
        return !!storage && storage.getItem(EMAIL_UNDELIVERABLE_STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function markPromptShown(storage) {
    try {
        if (storage) storage.setItem(EMAIL_UNDELIVERABLE_STORAGE_KEY, '1');
    } catch (e) {
        // ignore: worst case the prompt can be shown again after a reload
    }
}

/**
 * The prompt is shown at most once per browser session.
 */
export function shouldShowPrompt(user, storage) {
    return isEmailUndeliverable(user) && !wasPromptShown(storage);
}



// WEBPACK FOOTER //
// ./src/utils/emailUndeliverable.js